import React from "react";
import { IconsProps } from "./dto";

export function PlusIcon(props: IconsProps) {
    return (
        <svg className=" cursor-pointer" width={props.size} height={props.size} onClick={props.onClick} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M5 12H19" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}